import { Link } from "react-router-dom";

export default function Home() {
  return (
    <div
      className="home"
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "20px",
        flexDirection: "column",
        color: "blue",
      }}
    >
      <Link to="/login">Login</Link>
      <Link to="/register">SignUp</Link>
    </div>
  );
}
